export const GET_LAST_SEARCHED_DEFINITION = 'GET_LAST_SEARCHED_DEFINITION';
export const GET_LAST_VERB_CONJUAGATED = 'GET_LAST_VERB_CONJUAGATED';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const GET_VERBS = "GET_VERBS";
export const ADD_VERB = "ADD_VERB";
export const DELETE_VERB = "DELETE_VERB";
export const UPDATE_VERB = "UPDATE_VERB";
export const GET_NOUNS = "GET_NOUNS";
export const ADD_NOUN = "ADD_NOUN";
export const UPDATE_NOUN = "UPDATE_NOUN";
export const DELETE_NOUN = "DELETE_NOUN";
export const GET_ADJECTIVES = "GET_ADJECTIVES";
export const ADD_ADJECTIVE = "ADD_ADJECTIVE";
export const DELETE_ADJECTIVE = "DELETE_ADJECTIVE";
export const UPDATE_ADJECTIVE = "UPDATE_ADJECTIVE";
export const GET_ADVERBS = "GET_ADVERBS";
export const ADD_ADVERB = "ADD_ADVERB";
export const DELETE_ADVERB = "DELETE_ADVERB";
export const UPDATE_ADVERB = "UPDATE_ADVERB";
export const GET_PHRASALVERBS = "GET_PHRASALVERBS";
export const ADD_PHRASALVERB = "ADD_PHRASALVERB";
export const DELETE_PHRASALVERB = "DELETE_PHRASALVERB";
export const UPDATE_PHRASALVERB = "UPDATE_PHRASALVERB";
export const GET_LINKERS = "GET_LINKERS";
export const ADD_LINKER = "ADD_LINKER";
export const DELETE_LINKER = "DELETE_LINKER";
export const UPDATE_LINKER = "UPDATE_LINKER";
export const ADD_TOPIC = "ADD_TOPIC";
export const GET_TOPICS = "GET_TOPICS";
export const UPDATE_TOPIC = "UPDATE_TOPIC";
export const DELETE_TOPIC = "DELETE_TOPIC";
export const GET_TENSES = "GET_TENSES";
export const ADD_TENSE = "ADD_TENSE";
export const DELETE_TENSE = "DELETE_TENSE";
export const UPDATE_TENSE = "UPDATE_TENSE";
export const GET_NOTES = "GET_NOTES";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const DELETE_NOTE = "DELETE_NOTE";
export const ADD_NOTE = "ADD_NOTE";
export const GET_IDIOMS = "GET_IDIOMS";
export const ADD_IDIOM = "ADD_IDIOM";
export const UPDATE_IDIOM = "UPDATE_IDIOM";
export const DELETE_IDIOM = "DELETE_IDIOM";
export const GET_THINGS = "GET_THINGS";
export const ADD_THING = "ADD_THING";
export const DELETE_THING = "DELETE_THING";
export const GET_QA = "GET_QA";
export const ADD_QA = "ADD_QA";
export const UPDATE_QA = "UPDATE_QA";
export const DELETE_QA = "DELETE_QA";
export const GET_TODOS = "GET_TODOS";
export const ADD_TODO = "ADD_TODO";
export const UPDATE_TODO = "UPDATE_TODO";
export const DELETE_TODO = "DELETE_TODO";

